import React from "react"

const MediaDatabaseIframeBlock = ({ block }) => {
  return (
    <section className="py-block">
      <div className="block-w-container">
        <iframe
          title="Mediendatenbank"
          className="w-full h-screen"
          src={block.iframe_url}
        ></iframe>
      </div>
    </section>
  )
}

export default MediaDatabaseIframeBlock
